import { LinksListProps } from '~/components/LinksList/models';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { buttonMapper } from '../button';
import { linkMapper } from '../link';
import { LinksList } from './models';

export const linksListMapper = ({
  pageBlockUI: [pageBlockUI],
  componentId,
  variant,
  size,
  items,
}: LinksList) =>
  ({
    pageBlockUI: pageBlockUIMapper(pageBlockUI.ui),
    componentId,
    items: items.map(({ isButton, title, ...rest }) => ({
      isButton,
      ...(isButton
        ? buttonMapper({ ...rest, text: title, variant, size })
        : linkMapper({ ...rest, title, variant, size })),
    })),
  } as LinksListProps);
